export default __webpack_public_path__ + "static/media/diamond_loyalty_light.81fab3dd.svg";